<div *ngIf="warnings.includes(OTA_WARNING.NEW_GENERAL)" class="flex justify-center my-2">
    <div class="w-full">
        <div class="flex !gap-3 border border-palette-amber-600 bg-palette-amber-25 !p-[16px] rounded-lg">
            <i class="sctr-icon-alert-triangle !w-5 !h-5 text-lg !mt-[-4px] text-palette-amber-600"></i>
            <div>
                <p class="font-inter text-lg !leading-5 font-semibold text-palette-gray-900 !mb-1">
                    {{ 'OTA_WARNING.NEW_GENERAL_TT' | translate | sentenceCase}}
                </p>
                <p class="font-inter text-sm font-normal text-palette-gray-900"
                    [innerHTML]="'OTA_WARNING.NEW_GENERAL_DS' | translate">
                </p>                           
            </div>
        </div>
    </div>
</div>
<div *ngIf="warnings.includes(OTA_WARNING.EDITED_GENERAL)" class="flex justify-center my-2">
    <div
        class="w-full">
        <div class="flex !gap-3 border border-palette-amber-600 bg-palette-amber-25 !p-[16px] rounded-lg">
            <i class="sctr-icon-alert-triangle !w-5 !h-5 text-lg !mt-[-4px] text-palette-amber-600"></i>
            <div>
                <p class="font-inter text-lg !leading-5 font-semibold text-palette-gray-900 !mb-1">
                    {{ 'OTA_WARNING.EDITED_GENERAL_TT' | translate | sentenceCase}}
                </p>
                <p class="font-inter text-sm font-normal text-palette-gray-900">
                    {{'OTA_WARNING.EDITED_GENERAL_DS' | translate}}
                </p>                           
            </div>
        </div>
    </div>
</div>
<div *ngIf="warnings.includes(OTA_WARNING.REJECTED_GENERAL)" class="flex justify-center my-2">
    <div
        class="w-full">
        <div class="flex !gap-3 border border-palette-amber-600 bg-palette-amber-25 !p-[16px] rounded-lg">
            <i class="sctr-icon-alert-triangle !w-5 !h-5 text-lg !mt-[-4px] text-palette-amber-600"></i>
            <div>                           
                <p class="font-inter text-lg !leading-5 font-semibold text-palette-gray-900 !mb-1">
                    {{ 'OTA_WARNING.REJECTED_GENERAL_TT' | translate | sentenceCase}}
                </p>
                <p class="font-inter text-sm font-normal text-palette-gray-900"
                    [innerHTML]="'OTA_WARNING.REJECTED_GENERAL_DS' | translate">
                </p>
            </div>
        </div>
    </div>
</div>
<div *ngIf="warnings.includes(OTA_WARNING.EXPIRED_ID) && !isAdminView && (this.role == 'Owner' || this.role == 'Admin')" class="flex justify-center my-2">
    <div class="w-full">
        <div class="flex !gap-3 border border-palette-amber-600 bg-palette-amber-25 !p-[16px] rounded-lg">
            <i class="sctr-icon-alert-triangle !w-5 !h-5 text-lg !mt-[-4px] text-palette-amber-600"></i>
            <div class="w-full">
                <div class="w-full flex justify-between !gap-2">
                    <div>
                        <p class="font-inter text-lg !leading-5 font-semibold text-palette-gray-900 !mb-1">
                            {{ 'OTA_WARNING.EXPIRED_TT' | translate | sentenceCase}}
                        </p>
                        <p class="font-inter text-sm font-normal text-palette-gray-900"
                            [innerHTML]="'OTA_WARNING.EXPIRED_ID_DS' | translate">
                        </p>
                    </div>
                    <p (click)="navigateContactPage()"
                        class="text-palette-blue-600 font-medium text-sm cursor-pointer whitespace-nowrap">
                        {{ 'OTA.CONTRACT_AGREEMENT.UPDATE' | translate}}
                        <i class="sctr-icon-arrow-right font-medium text-sm"></i>
                    </p>
                </div>                           
            </div>
        </div>
    </div>
</div>
<div *ngIf="warnings.includes(OTA_WARNING.WILL_EXPIRED_ID) && this.expired_date && !isAdminView && (this.role == 'Owner' || this.role == 'Admin')" class="flex justify-center my-2">
    <div class="w-full">
        <div class="flex !gap-3 border border-palette-amber-600 bg-palette-amber-25 !p-[16px] rounded-lg">
            <i class="sctr-icon-alert-triangle !w-5 !h-5 text-lg !mt-[-4px] text-palette-amber-600"></i>
            <div class="w-full">
                <div class="w-full flex justify-between !gap-2">
                    <div>
                        <p class="font-inter text-lg !leading-5 font-semibold text-palette-gray-900 !mb-1">
                            {{ 'OTA_WARNING.WILL_EXPIRED_ID_TT' | translate | sentenceCase}}
                        </p>
                        <p class="font-inter text-sm font-normal text-palette-gray-900"
                            [innerHTML]="'OTA_WARNING.WILL_EXPIRED_ID_DS' | translate : { syntax: (this.expired_date | dateFormat) }">
                        </p>
                    </div>
                    <p (click)="navigateContactPage()"
                        class="text-palette-blue-600 font-medium text-sm cursor-pointer whitespace-nowrap">
                        {{ 'OTA.CONTRACT_AGREEMENT.UPDATE' | translate}}
                        <i class="sctr-icon-arrow-right font-medium text-sm"></i>
                    </p>
                </div>                           
            </div>
        </div>
    </div>
</div>
<div *ngIf="warnings.includes(OTA_WARNING.MISSING_CONTRACT)" class="flex justify-center my-2">
    <div class="w-full">
        <div class="flex !gap-3 border border-palette-amber-600 bg-palette-amber-25 !p-[16px] rounded-lg">
            <i class="sctr-icon-alert-triangle !w-5 !h-5 text-lg !mt-[-4px] text-palette-amber-600"></i>
            <div class="w-full">
                <div class="w-full flex justify-between !gap-2">
                    <div>
                        <p class="font-inter text-lg !leading-5 font-semibold text-palette-gray-900 !mb-1">
                            {{ 'OTA.CONTRACT_AGREEMENT.CONTRACT_WARNING_TITLE'
                            | translate | sentenceCase}}
                        </p>
                        <p class="font-inter text-sm font-normal text-palette-gray-900">
                            {{ 'OTA.CONTRACT_AGREEMENT.CONTRACT_WARNING' | translate | sentenceCase}}
                        </p>
                    </div>
                    <p (click)="navigateContactPage()"
                        class="text-palette-blue-600 font-medium text-sm cursor-pointer whitespace-nowrap">
                        {{ 'OTA.CONTRACT_AGREEMENT.UPDATE' | translate}}
                        <i class="sctr-icon-arrow-right font-medium text-sm"></i>
                    </p>
                </div>                           
            </div>
        </div>
    </div>
</div>